import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/salary-grades/profile/loading';

export const Route = createFileRoute('/_private/settings/salary-grades/$id')({
  pendingComponent: Loading,
});
